module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertoc01",
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertoc01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page viii. ",
      "epub:type": "pagebreak",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page ix. ",
      "epub:type": "pagebreak",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocfm",
    attrs: {
      "id": "rfore"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0010#fore"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rch01"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0011#ch01"
    }
  }, [_vm._v("1. Ashes to Ashes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch02"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0012#ch02"
    }
  }, [_vm._v("2. Beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch03"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0013#ch03"
    }
  }, [_vm._v("3. Chicago Reporter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch04"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0014#ch04"
    }
  }, [_vm._v("4. Upstate New York")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch05"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0015#ch05"
    }
  }, [_vm._v("5. My New York Year")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch06"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0016#ch06"
    }
  }, [_vm._v("6. Inside the Pyramid")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch07"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0017#ch07"
    }
  }, [_vm._v("7. Getting to Detroit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch08"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0018#ch08"
    }
  }, [_vm._v("8. "), _c('i', [_vm._v("Detroit Free Press")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch09"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0019#ch09"
    }
  }, [_vm._v("9. Union Activist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch10"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0020#ch10"
    }
  }, [_vm._v("10. On Strike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch11"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0021#ch11"
    }
  }, [_vm._v("11. The "), _c('i', [_vm._v("Detroit Sunday Journal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch12"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0022#ch12"
    }
  }, [_vm._v("12. Newspapers in Transition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch13"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0023#ch13"
    }
  }, [_vm._v("13. Detroit and the Urban Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch14"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0024#ch14"
    }
  }, [_vm._v("14. Cities: A Recovery Begins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch15"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0025#ch15"
    }
  }, [_vm._v("15. Writing Books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch16"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0026#ch16"
    }
  }, [_vm._v("16. A City in Bankruptcy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch17"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0027#ch17"
    }
  }, [_vm._v("17. An Aside: On Never Winning a Pulitzer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch18"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0028#ch18"
    }
  }, [_vm._v("18. Union President")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch19"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page x. ",
      "epub:type": "pagebreak",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0029#ch19"
    }
  }, [_vm._v("19. Pension Trustee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch20"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0030#ch20"
    }
  }, [_vm._v("20. Negotiations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch21"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0031#ch21"
    }
  }, [_vm._v("21. Columns and Flash Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch22"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0032#ch22"
    }
  }, [_vm._v("22. Detroit: The Recovery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rch23"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0033#ch23"
    }
  }, [_vm._v("23. When It’s Time to Move On")])]), _vm._v(" "), _c('p', {
    staticClass: "tocbmf",
    attrs: {
      "id": "raubio"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsugallagher0034#aubio"
    }
  }, [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5318c332","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-gallagher-0009.vue
// module id = 78
// module chunks = 0